import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfMdProcessHdrContainerModel, WfMdTransitionContainerModel } from "../../../../../../models";
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";
import { Observable } from "rxjs";
import { TransitionGenerateDto } from "../../../data-transfer-objects/transitions-generate-dto.model";

@Injectable({ providedIn: "root" })
export class WfMdTransitionService extends BaseApiTemplateService<WfMdTransitionContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/transitions";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/transitions";
    this.httpClient = http;
  }

  generateAllTransitionsForSpecificRoles(dtoObject: TransitionGenerateDto, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + 
      "md/transitions-with-role-links/generate-all-possible-transitions/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
